import {
  HRMonthlyAchievements,
  HRHeading,
  HRActivitiesOverview,
  HRMostActiveStudents,
  useHRPortalTranslation,
  useMonthlyAchievements,
  useOEMostActiveStudents,
  useByDateReport,
  useReport,
  useLiveClassReportByPeriod,
  SectionPlaceholder,
  flex,
  mb,
  HRStudentsHorizontalBarChart,
  OMStatisticsOfActivities,
  saveFile,
} from '@openeducation/hr-rn-components';
import {
  hrManagerAtom,
  useGetOMActivityIntervals,
  useGetOMAllActivitiesOverview,
} from '@openeducation/hr-rn-graphql-providers';
import { omLanguageSelected } from '@openeducation/hr-rn-jotai-atoms';
import { usePurchaserIds } from '@openeducation/hr-rn-providers';
import { ActivityType, ReportType } from '@openeducation/hr-rn-shared-types';
import { useAtomValue } from 'jotai';
import React from 'react';
import { View } from 'react-native';

import { useStudentsListProps } from '../../hooks/use-students-list-props';
import { OMPath } from '../../router';

const OMHomeScreen = () => {
  const hrManager = useAtomValue(hrManagerAtom);
  const { langCode: languageCode = undefined } = useAtomValue(omLanguageSelected) || {};
  const { t } = useHRPortalTranslation();
  const purchaserIds = usePurchaserIds();

  const {
    loading: activitiesOverviewLoading,
    data: activitiesOverviewData,
    isError: activitiesOverviewError,
  } = useGetOMAllActivitiesOverview({
    purchaserIds,
    languageCode,
  });

  const { mostActiveStudentsChartData, ...mostActiveStudentsProps } = useOEMostActiveStudents();

  useGetOMActivityIntervals({
    purchaserIds,
    languageCode,
  });

  const monthlyAchievementsProps = useMonthlyAchievements();

  const studentsListProps = useStudentsListProps(OMPath.Student);
  const historicalReport = useReport(saveFile, ReportType.HISTORICAL);
  const periodReport = useByDateReport(saveFile, ReportType.ACTIVITY_BY_PERIOD);
  const liveClassReportByPeriod = useLiveClassReportByPeriod(saveFile);

  return (
    <>
      <HRHeading
        title={t('home.heading.title', { managerName: hrManager?.name })}
        description={t('home.heading.description')}
        studentsListProps={studentsListProps}
        historicalReport={historicalReport}
        periodReport={periodReport}
        liveClassReportByPeriod={liveClassReportByPeriod}
        changeLanguageSelected
      />
      {!activitiesOverviewError && (
        <HRActivitiesOverview
          isLoading={activitiesOverviewLoading}
          stats={activitiesOverviewData}
          subtitle={t('home.activitiesOverview.subtitle')}
          isOM
        />
      )}
      <View style={[flex('flex-row', 'flex-1')]}>
        <OMStatisticsOfActivities languageCode={languageCode} />
      </View>
      <HRMonthlyAchievements<ActivityType> {...monthlyAchievementsProps} />
      <HRMostActiveStudents {...mostActiveStudentsProps}>
        <View style={[flex('flex-1'), mb(15)]}>
          {mostActiveStudentsChartData.values.length === 0 ? (
            <SectionPlaceholder text={t('common.chart.noData')} />
          ) : (
            <HRStudentsHorizontalBarChart {...mostActiveStudentsChartData} />
          )}
        </View>
      </HRMostActiveStudents>
    </>
  );
};

export default OMHomeScreen;
